import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import './SubscriptionNotes.scss';

function renderNote(note) {
  return note
    .map((content, idx) => (
      // eslint-disable-next-line react/no-array-index-key
      <li className="note-content" key={idx}>
        {content}
      </li>
    ))
    .toList();
}

export default function SubscriptionNotes({ notes }) {
  return (
    <div className="cp-subscription-notes">
      {notes
        .map((note, type) => (
          <ul className="note-type" key={`${type.toLowerCase()}-type`}>
            {renderNote(note)}
          </ul>
        ))
        .toList()}
    </div>
  );
}

SubscriptionNotes.propTypes = {
  notes: ImmutablePropTypes.map.isRequired
};
